module.exports = __webpack_public_path__ + "img/coupon-new-user.e4e8d754.png";